//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  name: 'nieuwsbriefForm',
  data() {
    return {
      terms: false,
      content: {
        email: '',
        segment: 'newslettermvh',
        subscribe: 1
      }
    }
  },
  computed: {
    ...mapState({
      formStatus: ({ formStore: {formStatus} }) => formStatus,
    }),
  },
  methods: {
    processForm: function() {
      var error = {};
      if (!this.content.email) {
        error.type = 'email';
        error.text = 'Je emailadres is ongeldig';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (!this.terms) {
        error.type = 'terms';
        error.text = 'Je moet akkoord gaan met de algemene voorwaarden en de geldende privacy verklaring';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (Object.keys(this.formStatus.errors).length === 0) {
        this.$store.dispatch('formStore/newsletter', this.content);
      } else {
        this.goto('nieuwsbrief');
        var notificationObj = {};
        notificationObj.type = 'error';
        notificationObj.message = 'Je formulier is niet verzonden. Vul ook de rood gekleurde velden in.';
        this.$store.commit('notificationStore/setNotification', notificationObj);  
        this.$forceUpdate();
      }
    },
  }
}
